
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "project-information"
    }}>{`Project Information`}</h1>
    <ul>
      <li parentName="ul">{`This document provides an overview of the various documents and links that are part of this project's general information. All of this content is automatically generated by `}<a parentName="li" {...{
          "href": "http://maven.apache.org"
        }}>{`Maven`}</a>{` on behalf of the project.`}</li>
    </ul>
    <h1 {...{
      "id": "overview"
    }}>{`Overview`}</h1>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Document`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "#/"
            }}>{`About`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Apache Atlas Documentation`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "#/TeamList"
            }}>{`Project Team`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This document provides information on the members of this project.`}<br />{` These are the individuals who have contributed to the project in one form or another.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "#/MailingLists"
            }}>{`Mailing Lists`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This document provides subscription and archive information for this project's mailing lists.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "#/IssueTracking"
            }}>{`Issue Tracking`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This is a link to the issue management system for this project.`}<br />{` Issues (bugs, features, change requests) can be created and queried using this link.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "#/ProjectLicense"
            }}>{`Project License`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This is a link to the definitions of project licenses.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "#/SourceRepository"
            }}>{`Source Repository`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This is a link to the online source repository that can be viewed via a web browser.`}</td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;